/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAppointments } from 'app/entities/appointments/appointments.reducer';
import { getEntities as getReminderOptions } from 'app/entities/reminder-options/reminder-options.reducer';
import { getEntities as getDurations } from 'app/entities/duration/duration.reducer';
import { createEntity, getEntity, reset, updateEntity } from './reminders.reducer';

export const RemindersUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const appointments = useAppSelector(state => state.appointments.entities);
  const reminderOptions = useAppSelector(state => state.reminderOptions.entities);
  const durations = useAppSelector(state => state.duration.entities);
  const remindersEntity = useAppSelector(state => state.reminders.entity);
  const loading = useAppSelector(state => state.reminders.loading);
  const updating = useAppSelector(state => state.reminders.updating);
  const updateSuccess = useAppSelector(state => state.reminders.updateSuccess);

  const handleClose = () => {
    navigate(`/reminders${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAppointments({}));
    dispatch(getReminderOptions({}));
    dispatch(getDurations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...remindersEntity,
      ...values,
      appointment: appointments.find(it => it.id.toString() === values.appointment?.toString()),
      reminderOptionCode: reminderOptions.find(it => it.id.toString() === values.reminderOptionCode?.toString()),
      durationCode: durations.find(it => it.id.toString() === values.durationCode?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...remindersEntity,
          appointment: remindersEntity?.appointment?.id,
          reminderOptionCode: remindersEntity?.reminderOptionCode?.id,
          durationCode: remindersEntity?.durationCode?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.reminders.home.createOrEditLabel" data-cy="RemindersCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.reminders.home.createOrEditLabel">Create or edit a Reminders</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="reminders-id"
                  label={translate('tinyMedicRestApp.reminders.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.reminderFor')}
                id="reminders-reminderFor"
                name="reminderFor"
                data-cy="reminderFor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.reminderNo')}
                id="reminders-reminderNo"
                name="reminderNo"
                data-cy="reminderNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 5, message: translate('entity.validation.maxlength', { max: 5 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.reminderTime')}
                id="reminders-reminderTime"
                name="reminderTime"
                data-cy="reminderTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 5, message: translate('entity.validation.maxlength', { max: 5 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.timestampentry')}
                id="reminders-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.microSec')}
                id="reminders-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.lastupdated')}
                id="reminders-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.active')}
                id="reminders-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.reminders.cursor')}
                id="reminders-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="reminders-appointment"
                name="appointment"
                data-cy="appointment"
                label={translate('tinyMedicRestApp.reminders.appointment')}
                type="select"
                required
              >
                <option value="" key="0" />
                {appointments
                  ? appointments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="reminders-reminderOptionCode"
                name="reminderOptionCode"
                data-cy="reminderOptionCode"
                label={translate('tinyMedicRestApp.reminders.reminderOptionCode')}
                type="select"
                required
              >
                <option value="" key="0" />
                {reminderOptions
                  ? reminderOptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="reminders-durationCode"
                name="durationCode"
                data-cy="durationCode"
                label={translate('tinyMedicRestApp.reminders.durationCode')}
                type="select"
                required
              >
                <option value="" key="0" />
                {durations
                  ? durations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/reminders" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RemindersUpdate;
